<ng-template #cutoutValue let-type="type" let-value="value" let-defaultAnyCutoutValue="defaultAnyCutoutValue">
  <ng-container *ngIf="type !== cutoutTypeEnum.Any; else anyCutout" i18n>{{ value }}</ng-container>
  <ng-template #anyCutout>
    <span *ngIf="defaultAnyCutoutValue">{{ defaultAnyCutoutValue }}</span>
    <span *ngIf="!defaultAnyCutoutValue" i18n="not available">n/a</span>
  </ng-template>
</ng-template>

<mat-table
  class="standard-cutouts-table"
  [dataSource]="cutouts"
  matSort
  (matSortChange)="sortChanged.emit($event)"
  cslPerfectScrollbar>
  <!-- Image Column -->
  <ng-container matColumnDef="image">
    <mat-header-cell *matHeaderCellDef class="basis-22 grow-0 pr-6"></mat-header-cell>
    <mat-cell *matCellDef="let item" class="basis-22 grow-0 pr-6">
      <img
        *ngIf="item.imageLink || item.fragmentImageLink"
        [src]="item.imageLink || item.fragmentImageLink"
        [alt]="item.name"
        class="max-w-10 max-h-10 block outline outline-offset-1 outline-1 outline-slate-400 rounded-md" />
    </mat-cell>
  </ng-container>

  <!-- Name Column -->
  <ng-container matColumnDef="name">
    <mat-header-cell *matHeaderCellDef i18n mat-sort-header="name">Название</mat-header-cell>
    <mat-cell *matCellDef="let item">
      <ng-container
        *ngTemplateOutlet="
          cutoutValue;
          context: { defaultAnyCutoutValue: anyCutoutName, type: item.type, value: item.name }
        "></ng-container>
    </mat-cell>
  </ng-container>

  <!-- Height Column -->
  <ng-container matColumnDef="height">
    <mat-header-cell *matHeaderCellDef i18n>Высота (мм)</mat-header-cell>
    <mat-cell *matCellDef="let item">
      <ng-container *ngTemplateOutlet="cutoutValue; context: { type: item.type, value: item.height }"></ng-container>
    </mat-cell>
  </ng-container>

  <!-- Width Column -->
  <ng-container matColumnDef="width">
    <mat-header-cell *matHeaderCellDef i18n>Ширина (мм)</mat-header-cell>
    <mat-cell *matCellDef="let item">
      <ng-container *ngTemplateOutlet="cutoutValue; context: { type: item.type, value: item.width }"></ng-container>
    </mat-cell>
  </ng-container>

  <!-- Radius Column -->
  <ng-container matColumnDef="radius">
    <mat-header-cell *matHeaderCellDef i18n>Радиус сопряжения (мм)</mat-header-cell>
    <mat-cell *matCellDef="let item">
      <ng-container *ngTemplateOutlet="cutoutValue; context: { type: item.type, value: item.radius }"></ng-container>
    </mat-cell>
  </ng-container>

  <!-- Type Column -->
  <ng-container matColumnDef="type">
    <mat-header-cell *matHeaderCellDef i18n>Тип</mat-header-cell>
    <mat-cell *matCellDef="let item">
      {{ getCutoutTypeName(item.type) }}
    </mat-cell>
  </ng-container>

  <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>

  <mat-row
    matRipple
    (click)="selectChanged.emit(item.id === 0 ? undefined : item)"
    *matRowDef="let item; columns: displayedColumns"
    class="cursor-pointer">
  </mat-row>
</mat-table>
